<template>
  <v-container>
    <v-row class="ma-0 pa-0">
      <!--Twitter Feed-->
      <TwitterFeedCard></TwitterFeedCard>
      <!--NRK Feed-->
      <NrkFeedCard></NrkFeedCard>
      <!--Nav Feed-->
      <NavFeedCard></NavFeedCard>
      <!--Bronnoysund Feed-->
      <Bronnoysund></Bronnoysund>
    </v-row>
  </v-container>
</template>

<script>
import TwitterFeedCard from "../cards/twitterFeedCard.vue";
import NrkFeedCard from "../cards/nrkFeedCard.vue";
import NavFeedCard from "../cards/navFeedCard.vue";
import Bronnoysund from "../cards/bronnoysundFeedCard.vue";
export default {
  components:{
    TwitterFeedCard,
    NrkFeedCard,
    NavFeedCard,
    Bronnoysund
  },
  data(){
    return {
      
    }
  }
}
</script>